import { applyMiddleware, compose } from "redux";
import { legacy_createStore as createStore } from "redux";
import {thunk} from "redux-thunk";
import RootReducer from "../reducers/RootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = createStore(
  persistedReducer,
  applyMiddleware(thunk)
);

// const persistor = persistStore(store);

// export { store, persistor };
export { store };
